'use client';
import styled from 'styled-components';

//* Because stylelint sucks
const getColumnWidth = props => {
  const spacing = props.theme.spacing(6);
  const columns = props.$columns;
  return `calc((100% - (${spacing} * (${columns} - 1))) / ${columns})`;
};

export const StyledInformationStats = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${props => props.theme.spacing(10, 4, 4)};
  text-align: center;
  box-sizing: border-box;
  background-color: ${props =>
    props.theme.colors.get(
      props.$backgroundColor,
      props.theme.colors.background.base,
    )};
`;

export const InformationStatsBlocksContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: ${props => props.theme.spacing(6)};
  padding: ${props => props.theme.spacing(6)};
  width: 80vw;

  @media ${props => props.theme.tabletL} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: stretch;
    gap: ${props => props.theme.spacing(6)};
    max-width: 1440px;
    width: 60vw;

    > * {
      flex: 0 0 ${getColumnWidth};
      width: ${getColumnWidth};
      max-width: ${getColumnWidth};
      margin: 0;
      display: flex;
      flex-direction: column;
    }
  }
`;

export const InformationStatsBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  width: 100%;
  height: 160px;
  padding: 20px;
  margin: ${props => props.theme.spacing(2, 0)};
  border-radius: ${props => props.theme.spacing(8)};
  overflow-wrap: break-word;

  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor
      ? theme.colors.get(backgroundColor)
      : theme.colors.background.dark};
  color: ${({ theme, textColor }) =>
    textColor ? theme.colors.get(textColor) : theme.colors.neutral.white};

  @media ${props => props.theme.tabletL} {
    padding: 20px;
    margin: ${props => props.theme.spacing(0)};
    width: 100%;
    height: 100%;
    min-height: 200px;
    max-height: 450px;
  }
`;

export const BlockHeading = styled.p`
  ${({ theme }) => theme.typography.heading1};
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor
      ? theme.colors.get(backgroundColor)
      : theme.colors.background.dark};
  color: ${({ theme, textColor }) =>
    textColor ? theme.colors.get(textColor) : theme.colors.neutral.white};
  text-align: center;
`;

export const Paragraph = styled.p`
  ${props => props.theme.typography.heading5};
  ${props => props.theme.fontFamily.base};
  text-align: center;
  margin: ${props => props.theme.spacing(0)};
  color: ${props =>
    props.$fontColor
      ? props.theme.colors.get(props.$fontColor)
      : props.theme.colors.neutral.dark};
`;

export const DescriptionParagraph = styled.p`
  ${props => props.theme.typography.body};
  color: ${({ theme, textColor }) =>
    textColor ? theme.colors.get(textColor) : theme.colors.neutral.white};
  text-align: center;
`;
